import { useState, useEffect } from 'react';
import { CityData } from '../types/parameters.types';

const cityCache = new Map<string, CityData[]>();

type IbgeMunicipio = {
	id: number;
	nome: string;
	microrregiao: { mesorregiao: { nome: string } };
};

export function useStateCities(stateCode: string | null): { cities: CityData[]; loading: boolean } {
	const [cities, setCities] = useState<CityData[]>(
		stateCode ? (cityCache.get(stateCode) ?? []) : []
	);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (!stateCode) return;

		if (cityCache.has(stateCode)) {
			setCities(cityCache.get(stateCode) ?? []);
			return;
		}

		const controller = new AbortController();
		setLoading(true);

		fetch(
			`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${stateCode}/municipios?orderBy=nome`,
			{ signal: controller.signal }
		)
			.then((r) => r.json())
			.then((data: IbgeMunicipio[]) => {
				const mapped: CityData[] = data.map((c) => ({
					id: c.id,
					name: c.nome,
					mesoregion: c.microrregiao.mesorregiao.nome,
				}));
				cityCache.set(stateCode, mapped);
				setCities(mapped);
			})
			.catch((err) => {
				if (err.name !== 'AbortError') {
					setCities([]);
				}
			})
			.finally(() => setLoading(false));

		return () => controller.abort();
	}, [stateCode]);

	return { cities, loading };
}
